import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";

export const getUserProfileById = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_USERPROFILE_BY_ID_API}?id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
export const addUserProfile = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.UPDATE_USERPROFILE_ADD_API,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const updateUserProfile = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.UPDATE_USERPROFILE_UPDATE_API,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
export const updateUserProfileImage = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true, true));
    const response = await axioClient.post(
      apiendpoints.UPDATE_USERPROFILE_IMAGE_API,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
